<template>
  <new-policy-prompt :dialog.sync="dialog" :policy="policy" />
</template>

<script>
import { FB_BUY_PAYMENT_SUCCESS, FB_PUSH_NOTIFICATION, NOTIFICATIONS } from '@/utils/const';
import firebase from '@/services/firebase/firebase';
import axios from 'axios';
import { mapGetters } from 'vuex';
import NewPolicyPrompt from '@/components/shared/NewPolicyPrompt';

export default {
  name: 'NotificationPrompt',
  components: { NewPolicyPrompt },
  computed: {
    ...mapGetters('auth', ['authenticatedUser']),
  },
  data() {
    return {
      policy: {},
      dialog: false,
    };
  },
  mounted() {
    if (!firebase.messaging.isSupported()) {
      return;
    }

    const messaging = firebase.messaging();
    messaging.usePublicVapidKey(process.env.VUE_APP_FIREBASE_PUBLIC_KEY);

    if (Notification.permission === 'granted') {
      messaging.getToken().then((token) => {
        this.sendTokenToServer(token);
      });
    }

    messaging.onTokenRefresh(() => {
      messaging.getToken()
        .then((refreshedToken) => {
          this.setTokenSentToServer(false);
          this.sendTokenToServer(refreshedToken);
        })
        .catch(() => {
          this.setTokenSentToServer(false);
        });
    });

    messaging.onMessage((payload) => {
      let title = '';
      let body = '';
      this.$analytics.logEvent(FB_PUSH_NOTIFICATION);
      if ('data' in payload) {
        try {
          title = payload.data.title;
          const data = JSON.parse(payload.data.payload);
          if (data.notification_type === 'quoteSuccessPayment') {
            this.policy = data.notification_body;
            this.dialog = true;
            body = `Your Payment for quote No. ${data.notification_body.quote_id} is successful, Your Policy No is ${data.notification_body.policy_number}`;
            this.$root.$emit('successful-payment');
            this.$analytics.logEvent(FB_BUY_PAYMENT_SUCCESS);
          } else if (data.notification_type === 'RESUME_QUOTE') {
            body = data.notification_body.title;
          } else {
            body = data.notification_body;
          }
        } catch (e) {
          body = payload.data.payload;
          this.$notify.info(body, 'Info');
          if (body.includes('Your transaction for quote')) {
            this.$root.$emit('failed-payment');
          }
        }
      } else {
        body = payload.notification.body;
        title = payload.notification.title || 'Pacis Insurance';
      }
      return new Notification(title, { body, icon: `${window.location.origin}/pacis-logo.png` });
    });

    this.$root.$on('request-notification', () => {
      this.registerTokenIfPermitted();
    });

    this.$store.dispatch('getNotificationCount');
  },
  methods: {
    isTokenSentToServer() {
      return localStorage.getItem(NOTIFICATIONS) === '1';
    },
    setTokenSentToServer(sent) {
      localStorage.setItem(NOTIFICATIONS, sent ? '1' : '0');
    },
    setTokenToTopic(token) {
      const data = {
        token,
        kraPin: this.authenticatedUser['custom:kra-pin'],
        appVersionCode: 263,
        deviceId: 'web',
        userName: this.authenticatedUser.email,
      };
      axios.post('/customer/notification/fcm/updateUserDeviceFcmToken', data, { _skipErrorRedirect: true })
        .then(() => {
          this.setTokenSentToServer(true);
        })
        .catch((err) => {
          console.error('FCM token registration failed', err);
        });
    },
    sendTokenToServer(currentToken) {
      if (!this.isTokenSentToServer()) {
        this.setTokenToTopic(currentToken);
      }
    },
    registerTokenIfPermitted() {
      if (!('Notification' in window) || Notification.permission !== 'granted') {
        return;
      }
      const messaging = firebase.messaging();
      messaging.getToken().then((token) => {
        this.sendTokenToServer(token);
      });
    },
  },
};
</script>
